import { render, staticRenderFns } from "./RecargoCrud.vue?vue&type=template&id=32b73cae&"
import script from "./RecargoCrud.vue?vue&type=script&lang=js&"
export * from "./RecargoCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports